'use client'

import { usePathname } from '@repo/shared/i18n/navigation'
import { useIsDesktop } from '@repo/ui/hooks'
import { useMemo } from 'react'
import { WithdrawCTA } from './withdraw.cta'

export const WalletWithdrawHeaderLayout = () => {
  const pathname = usePathname()

  const routeItems = [
    {
      component: <WithdrawCTA origin='layout' />,
      link: '/wallet/withdraw/online-payment',
    },
    {
      component: <WithdrawCTA origin='layout' />,
      link: '/wallet/withdraw',
    },
  ]
  const isDesktop = useIsDesktop()
  const activeIndex = useMemo(() => {
    return routeItems.findIndex((route) => pathname?.includes(route.link))
  }, [pathname])
  return !isDesktop ? routeItems[activeIndex]?.component : undefined
}
